export const DEFAULT_TRIM_CTA_NAME = 'Find Best Price';
